import { SkillBase } from '../models/@competentNL/Skills/Skills';
import { shuffleArray } from './array';

export const searchSkillOptionsOnQuery = (options: SkillBase[], query: string): SkillBase[] => {
    try {
        const searchQuery = new RegExp(query, 'i');

        return options.filter(item => item.label.match(searchQuery));
    } catch {
        return [];
    }
};

export const sortSkillOptions = (options: SkillBase[]): SkillBase[] => (
    options.sort((option, comparisonOption) => option.label.localeCompare(comparisonOption.label))
);

export const getRandomExampleOptions = (options: SkillBase[], amount = 2): string => {
    const maxLength = 14;
    const shortOptions = options.filter(option => option.label.length <= maxLength);
    const shuffledOptions = shuffleArray<SkillBase>(shortOptions);

    return shuffledOptions
        .slice(0, amount)
        .map(option => option.label)
        .join(', ');
};
